export default __webpack_public_path__ + "static/media/27.c6554e2f.jpeg";